import { ServiceResponse } from "../../api/ServiceResponse";
import { UserDto } from "./UserDto";

export class UserResponse extends ServiceResponse {
  userList?: UserDto[] | null;
  count?: number | null;

  constructor(init?: Partial<UserResponse>) {
    super(init); // call parent constructor
    Object.assign(this, init);
  }

  // Getters
  getUserList(): UserDto[] | null | undefined {
    return this.userList;
  }

  getCount(): number | null | undefined {
    return this.count;
  }

  // Setters
  setUserList(userList: UserDto[] | null | undefined): void {
    this.userList = userList;
  }

  setCount(count: number | null | undefined): void {
    this.count = count;
  }
}
